import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { ConfirmDialog } from '../../../common/views/modals/confirmDialog/ConfirmDialog';
import { platformName } from '../platformMeta';
import type { CalendarPost } from '../types';

interface DeletePostConfirmProps {
  post: CalendarPost | null;
  isBusy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** "Delete this post?" for a draft, a failed or a canceled post (owner answer 2). */
const DeletePostConfirmComponent: React.FC<DeletePostConfirmProps> = ({ post, isBusy, onConfirm, onCancel }) => {
  const intl = useIntl();
  return (
    <ConfirmDialog
      isOpen={post !== null}
      tone="danger"
      testId="delete-post-confirm"
      title={
        post?.status === 'draft'
          ? intl.formatMessage({
              id: 'app.sml.promote.calendar.deleteDraft.title',
              defaultMessage: 'Delete this draft?',
            })
          : intl.formatMessage({ id: 'app.sml.promote.calendar.deletePost.title', defaultMessage: 'Delete this post?' })
      }
      description={intl.formatMessage(
        {
          id: 'app.sml.promote.calendar.deletePost.body',
          defaultMessage: 'The {platform} post leaves the Calendar. This cannot be undone.',
        },
        { platform: post === null ? '' : platformName(post.platform) }
      )}
      confirmLabel={intl.formatMessage({ id: 'app.sml.promote.calendar.deletePost.confirm', defaultMessage: 'Delete' })}
      isBusy={isBusy}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export const DeletePostConfirm = TypedMemo(DeletePostConfirmComponent);
